<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card>
      <v-card-title>{{ selectedLang.name }}</v-card-title>
      <div class="flag-container">
        <div
          class="flag-item"
          v-for="(item, index) in languages"
          :key="item + index"
        >
          <v-btn
            @click="selectedLang = item"
            active-class="active-btn"
            :color="selectedLang.lang === item.lang ? '#4caf50' : '#fff'"
          >
            <country-flag :country="item.flag" size="normal" />
          </v-btn>
        </div>
      </div>
      <v-card-actions>
        <v-layout row wrap justify-center>
          <v-btn block flat @click="closeDialog" class="close-btn"
            >Cancel</v-btn
          >
          <v-btn block flat @click="saveSelectedLang" class="close-btn"
            >Save</v-btn
          >
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import CountryFlag from "vue-country-flag";
import Langugaes from "../components/internationalization/languages";
import GlobalService from "../services/global-service";
// import I18n from "../components/internationalization/i18n";

export default {
  name: "LanguageSelection",
  components: {
    CountryFlag
  },
  data() {
    return {
      languages: Langugaes.languages,
      dialog: false,
      selectedLang: {}
    };
  },
  props: {
    selectedLanguage: {
      type: Object,
      default: () => {}
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
    selectedLanguage: function(newVal) {
      this.selectedLang = newVal;
    }
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getTechAccess"]),
    getLanguage() {
      return localStorage.getItem("language");
    }
  },
  mounted() {
    this.selectedLang = this.selectedLanguage;
  },
  methods: {
    async saveSelectedLang() {
      // window.I18n = new I18n(this.selectedLang.lang);
      window.selectedLang = await GlobalService.getLang(this.selectedLang.lang);
      localStorage.setItem("language", this.selectedLang.lang);
      this.$store.commit("global/setLanguage", this.selectedLang.lang);
      this.closeDialog();
    }
  }
};
</script>
<style>
.active-btn {
  color: rgba(114, 7, 7, 0.87);
}
.flag-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}
.flag-container .flag-item .v-btn__content {
  padding-left: 30px;
}
</style>
